// Chakra Imports
import {
  Avatar,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom Components
import {ItemContent} from "components/menu/ItemContent";
import {SearchBar} from "components/navbar/searchBar/SearchBar";
import {SidebarResponsive} from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React from "react";
// Assets
import {
  MdAccountCircle,
  MdAccountBalance,
} from "react-icons/md";
import routes from "routes.js";
import useAuthentication from "hooks/UseAuthentication";

import {useNavigate} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {loggedInUserState} from "atoms/loggedInUserState";
import {IoLogOutOutline} from "react-icons/io5";
import logger from "infra/logger";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import {onlyOtherAdminsAndPropertyOwners} from "utils/accessLevels";

const HeaderLinks = (props) => {
  const {logout} = useAuthentication();
  const loggedInUser = useRecoilValue(loggedInUserState);
  const {secondary} = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");

  const navigate = useNavigate();

  const signOutHandler = async () => {
    try {
      await logout();
    } catch (error) {
      logger.error("Error occurred while signing out:", error);
    }
  };

  const changeToSettings = async () => {
    navigate("/admin/account");
  };

  return (
    <Flex
      w={{base: "100%", sm: "100%", md: "auto"}}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? {base: "wrap", md: "nowrap"} : "unset"}
      p={{ base: "8px", md: "10px" }}
      borderRadius="30px"
      boxShadow={shadow}
      justifyContent={{ base: "space-between", md: "flex-end" }}
    >
      {/* <SearchBar
        mb={secondary ? { base: "10px", md: "unset" } : "unset"}
        me="10px"
        borderRadius="30px"
      /> */}
      <Flex
        bg={ethBg}
        display={secondary ? "flex" : "none"}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      ></Flex>
      <SidebarResponsive routes={routes} />

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{cursor: "pointer"}}
            color="white"
            name={loggedInUser?.name}
            bg="brand.500"
            size="sm"
            w={{ base: "36px", md: "40px" }}
            h={{ base: "36px", md: "40px" }}
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          w={{ base: "250px", sm: "280px", md: "100%" }}
          minW={{ base: "250px", sm: "280px" }}
        >
          <Flex
            w="100%"
            mb="0px"
            direction={"row"}
            align="center"
            justifyContent={"flex-start"}
            pl={5}
            borderBottom="1px solid"
            borderColor={borderColor}
            color="black"
          >
            <MdAccountCircle size={30} color="#23A979" />
            <Text
              ps={{ base: "12px", sm: "20px" }}
              pt="16px"
              pb="10px"
              w="100%"
              fontSize={{ base: "sm", md: "md" }}
              fontWeight="700"
              color={textColor}
              noOfLines={1}
            >
              {loggedInUser?.name.toUpperCase()}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px" gap={"3px"}>
            <RoleBasedRender roles={onlyOtherAdminsAndPropertyOwners}>
              <MenuItem
                _focus={{bg: "none"}}
                borderRadius="8px"
                bg="#e4e8ff"
                py={6}
                px={4}
                justifyContent="start"
                color="blue"
                fontSize="sm"
                icon={<MdAccountBalance size={25} />}
                _hover={{
                  bg: "blue",
                  color: "white",
                }}
                onClick={changeToSettings}
              >
                Account
              </MenuItem>
            </RoleBasedRender>

            <MenuItem
              _focus={{bg: "none"}}
              borderRadius="8px"
              bg="#fef2f1"
              py={6}
              px={4}
              justifyContent="start"
              color="red"
              fontSize="sm"
              icon={<IoLogOutOutline size={25} />}
              _hover={{
                bg: "red",
                color: "white",
                transition: ".25s all ease",
              }}
              onClick={signOutHandler}
            >
              Log out
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
};

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};

export default HeaderLinks;
